import {
    // FILE_UPLOAD,
    CREATE_TASK,
    RETRIEVE_TASK,
    RETRIEVESINGLE_TASK,
    UPDATE_TASK,
    DELETE_TASK,
} from "./type";
import Task from "../service/Task";
export const create = (data) => async (dispatch) => {
    try {
        const res = await Task.create(data);
        dispatch({
            type: CREATE_TASK,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await Task.fetchList(data);
        dispatch({
            type: RETRIEVE_TASK,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await Task.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_TASK,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await Task.update(data);
        dispatch({
            type: UPDATE_TASK,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await Task.changeStatus(data);
//         dispatch({
//             type: UPDATE_TASK,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await Task.trash(data);
        dispatch({
            type: DELETE_TASK,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};